import { createFileRoute } from '@tanstack/react-router'
import { internVacancySearchSchema } from '@/features/vacancies/filter-intern-vacancies/model/internVacancySearch'
import { InternVacanciesPage } from '@/pages/vacancies/ui/InternVacanciesPage'

export const Route = createFileRoute('/vacancy-search')({
  validateSearch: internVacancySearchSchema,
  component: InternVacanciesPage,
})
